import Axios from '@/api/http'

/**
 * 系统列表（应用列表）
 * */
export function openapiGetusercategorylist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getusercategorylist',
    data: query
  })
}

/**
 * 我发起的
 * */
export function openapiGetuserapprovinglist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovinglist',
    data: query
  })
}
/**
 * 收藏
 * */
export function subscribeapproval (query) {
  return Axios({
    method: 'post',
    url: '/openapi/subscribeapproval',
    data: query
  })
}

/**
 * 告知我的
 * */
export function openapiGetuserccapprovallist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserccapprovallist',
    data: query
  })
}

/**
 * 获取类型数据
 * */
export function openapiGetuserapprovalcommit (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovalcommit',
    data: query
  })
}

/**
 * 办理概况（我填写的、待我处理、已处理的）
 * */
export function openapiGetuserapprovinghandlelist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovinghandlelist',
    data: query
  })
}

/**
 * 办理概况（待阅）
 * */
export function openapiGetuserccapprovalhandlelist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserccapprovalhandlelist',
    data: query
  })
}

/**
 * 办理概况（获取类型数据）
 * */
export function openapiGetuserapprovalcommithandle (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovalcommithandle',
    data: query
  })
}

/**
 * 获取待办等小圆点数据
 * */
export function openapiGetapprovaltodonum (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovaltodonum',
    data: query
  })
}

/**
 * 全部已读
 * */
export function openapiUpdateuserccapprovingstatus (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserccapprovingstatus',
    data: query
  })
}
/**
 * 获取区块链数据
 * */
export function getcochaindata (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcochaindata',
    data: query
  })
}
/**
 * 查询是否有必填字段
 * */
export function validateupdateuserapproving(query) {
  return Axios({
    method: 'post',
    url: '/openapi/validateupdateuserapproving',
    data: query
  })
}

/**
 * 审批同意、拒绝按钮、转办
 * */
export function openapiUpdateuserapproving(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserapproving',
    data: date
  })
}
/**
 * 批量审批同意、拒绝按钮
 * */
export function batchupdateapprovalprocess(date) {
  return Axios({
    method: 'post',
    url: '/openapi/batchupdateapprovalprocess',
    data: date
  })
}

/**
 * 批量判断是否有必填字段
 * */
export function batchvalidateupdateuserapproving(date) {
  return Axios({
    method: 'post',
    url: '/openapi/batchvalidateupdateuserapproving',
    data: date
  })
}

/**
 * 数据解析
 * */
export function transapprovingfilebyapproval (date) {
  return Axios({
    method: 'post',
    url: '/api/transapprovingfilebyapproval',
    data: date
  })
}

/**
 * 获取数据解析内容
 * */
export function getapprovingfilecontent (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovingfilecontent',
    data: date
  })
}